import dayjs from 'dayjs'

const isOverlapped = (a, b) =>
  dayjs(a.startTime).isBefore(b.endTime) &&
  dayjs(b.startTime).isBefore(a.endTime)

/**
 * @param {CampaignBudgetFormModel[] | TemporaryCampaignBudgetFormModel[]} campaignBudgets
 * @returns {number[]} 期間が重複している campaignBudget の対象 index の配列を index ごとに格納した配列
 */
const getOverlappingIndicesList = campaignBudgets =>
  campaignBudgets.map((budget, index) => {
    return campaignBudgets
      .map((otherBudget, otherIndex) => {
        if (index !== otherIndex && isOverlapped(budget, otherBudget)) {
          return [otherIndex]
        } else {
          return []
        }
      })
      .flat()
  })

export default getOverlappingIndicesList
